export const API_BASE_URL = "https://api.yiino.com" 
export const S3_URL = "https://yiino-store.s3.amazonaws.com/yiino"